/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import { Form } from '@organisms';

const SelectField = ({ options = [], selectOptions, ...props }) => {
  return (
    <Form.Item {...props}>
      <Select {...selectOptions}>
        {options.map((option, index) => (
          <Select.Option key={index} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SelectField;
